import React from 'react';
import styles from '../LayoutDetail.module.css';

const TabNavigation = ({ activeTab, onTabChange, devicesCount }) => {
    return (
        <div className={styles.tabNavigation}>
            <button 
                className={`${styles.tabButton} ${activeTab === 'detail' ? styles.active : ''}`}
                onClick={() => onTabChange('detail')}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                </svg>
                Detail
            </button>
            <button 
                className={`${styles.tabButton} ${activeTab === 'devices' ? styles.active : ''}`}
                onClick={() => onTabChange('devices')}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
                Devices ({devicesCount})
            </button>
        </div>
    );
};

export default TabNavigation; 